export var EditContactEvent;
(function (EditContactEvent) {
    EditContactEvent["OPEN_ADD_FIELD_DROPDOWN"] = "OPEN_ADD_FIELD_DROPDOWN";
    EditContactEvent["FIELD_ACTION_CLICK"] = "FIELD_ACTION_CLICK";
    EditContactEvent["CLICK_VIEW_CONTACT"] = "CLICK_VIEW_CONTACT";
    EditContactEvent["SELECT_ASSIGNEE"] = "SELECT_ASSIGNEE";
})(EditContactEvent || (EditContactEvent = {}));
export var LabelsSelectorEvents;
(function (LabelsSelectorEvents) {
    LabelsSelectorEvents["LABEL_SELECTED"] = "LABEL_SELECTED";
})(LabelsSelectorEvents || (LabelsSelectorEvents = {}));
//# sourceMappingURL=events.js.map